/***
*
*   STAT
*   Statistic value with optional icon and -/+ change value
*
*   PROPS
*   value:  numeric value
*   label: string
*   loading: boolean to toggle loading animation (optional)
*   icon: icon to use (optional)
*   change: positive/negative number indicating change amount (optional)
*
**********/

import React from 'react'
import { Card, Icon, Loader, ClassHelper } from 'components/lib';
import Style from './stat.tailwind.js';
import { InfoIconWithTooltip } from 'icon-with-tooltip';

export function Stat(props){

  const changeUp = props.change?.toString().includes('-') ? false : true;

  // is loading
  if (props.loading || props.value === undefined){
    return (
      <Card>
        <div className={ Style.stat }>
          <Loader />
        </div>
      </Card>
    );
  }

  const statStyle = ClassHelper(Style, {

    stat: true, 
    //className: props.className

  })

  return(
    <Card className={ props.userCardStat ? Style.userCardStat : props.communityStat ? Style.communityStat : null }>
      <div className={ props.communityStat ? 'relative text-center min-h-max !p-0' : statStyle}>
      {props.description && <InfoIconWithTooltip text={props.description} placement="right" />}
        { props.icon &&
          <Icon
            color='dark'
            image={ props.icon }
            size={ 20 }
            className={ Style.icon }
          />
        }

        <div className={ props.small ? Style.valueSmall : Style.value }>{ props.value }</div>
        <div className={ props.labelSmall ? Style.labelSmall : Style.label }>{ props.label }</div>

        { props.change &&
          <div className={ Style.change }>

            { props.change }

            <Icon   
              color={ changeUp ? 'green' : 'red' }
              image={ changeUp ? 'arrow-up' : 'arrow-down' } 
              className={ Style.changeIcon }
            />

          </div>
        }
      </div>
    </Card>
  );
}